import {
    CANVAS_ACCESS_META_FAILURE,
    CANVAS_ACCESS_META_REQUEST,
    CANVAS_ACCESS_META_SUCCESS,
} from './canvasAccessCategoryTypes'

const initialState = {
    loading: false,
    loadingMessage: '',
    fetchSuccess: false,
    canvasAccessData: [],
    message: '',
    error: '',
}

const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case CANVAS_ACCESS_META_REQUEST:
            return {
                ...state,
                loading: true,
                loadingMessage: 'Fetching canvas access data...',
                fetchSuccess: false,
                canvasAccessData: {},
                message: '',
                error: '',
            }
        case CANVAS_ACCESS_META_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingMessage: '',
                fetchSuccess: true,
                canvasAccessData: action.payload,
                message: '',
                error: '',
            }
        case CANVAS_ACCESS_META_FAILURE:
            return {
                ...state,
                loading: false,
                loadingMessage: '',
                fetchSuccess: false,
                canvasAccessData: {},
                message: '',
                error: action.payload,
            }
        default:
            return state
    }
}

export default reducer
